import React, { FunctionComponent } from 'react';
import { setBearerAction } from 'Quotes/actions';
import { bearerForDisplay } from 'shared/utils/connectionCapacity';
import {
  BearerType,
  bearerTypes,
  bearerTypesOptical,
} from 'Quotes/QuoteBuilder/components/Configure/Bearer/BearerType';
import { useDispatch, useSelector } from 'react-redux';
import { selectBearer, selectCommonCircuitOptions } from 'Quotes/selectors'; //selectP2CCTBearers, selectProductType 
import { OptionGroup } from 'shared/components/organisms/OptionGroup/OptionGroup';

export const Bearer: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  return <DefaultBearer />;
};
 
const DefaultBearer: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const commonCircuitOptions = useSelector(selectCommonCircuitOptions)
  const commonBearers = commonCircuitOptions?.ports ?? [];
  const rapidActivationBearers = commonCircuitOptions?.rapid_activation_ports ?? [];
  const allBearers = [...new Set([...bearerTypes, ...bearerTypesOptical])];

  return <GenericBearer allBearers={allBearers} availableBearers={commonBearers} rapidActivationBearers={rapidActivationBearers} />;
};

function GenericBearer({
  allBearers,
  availableBearers,
  rapidActivationBearers
}: {
  allBearers: BearerType[];
  availableBearers: BearerType[];
  rapidActivationBearers: BearerType[];
}) {
  const dispatch = useDispatch();
  const selectedBearer = useSelector(selectBearer);
  return (
    <>
      <BearerHeader />

      <OptionGroup<BearerType>
        options={getBearerOptions(allBearers, availableBearers, rapidActivationBearers)}
        value={selectedBearer}
        onClick={(value) => {
          dispatch(setBearerAction(value));
        }}
      />
    </>
  );
}

function getBearerOptions(
  allBearers: BearerType[], 
  availableBearers: BearerType[], 
  rapidActivationBearers: BearerType[]
) {
  
  return allBearers.map((bearerValue) => ({
    label: bearerForDisplay(bearerValue),
    value: bearerValue,
    disabled: !availableBearers.includes(bearerValue),
    customId: `bearer--${bearerValue}`,
    tooltip: !availableBearers.includes(bearerValue)
      ? 'This option is unavailable based on your current selections'
      : (rapidActivationBearers.includes(bearerValue) ? 'Rapid activation available' : undefined),
    tooltipIcon: rapidActivationBearers.includes(bearerValue) ? 'bolt' : undefined,
  }));
}

export function BearerHeader() {
  return <h5 className="h5 pb-2">Bearer size</h5>;
}
